import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AddSalesPersonModal from './SalesPerson';
import ItemTable from './ItemTable';
import TotalSection from './TotalSection';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import '../../CSS/Global.css';
import Select from 'react-select';
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';


const NewInvoice = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const editInvoice = location.state?.invoice;
  const [modalOpen, setModalOpen] = useState(false);
  const [salesPersons, setSalesPersons] = useState([]);
  const [newSalesPerson, setNewSalesPerson] = useState({ name: '', email: '' });
  const [invoiceNumberNumeric, setInvoiceNumberNumeric] = useState('');
  const invoicePrefix = "INVE";
  const [invoiceNumberError, setInvoiceNumberError] = useState("");
  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-CA');
  const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
  const [data, setData] = useState({
    customer_name: "",
    invoice_number: "",
    order_number: "",
    invoice_date: "",
    terms: "",
    due_date: "",
    sales_person_name: "",
    customer_id: "",
    sales_person_id: "",
    invoice_no: "",
    order_no: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitType, setSubmitType] = useState("");




  const [items, setItems] = useState([
    { id: 1, item: null, quantity: "", rate: "", discount: "", tax: "" },
  ]);


  const [customerNote, setCustomerNote] = useState("");
  const [shipping, setShipping] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [advance_payment, setAdvancePayment] = useState(0);
  const [staffList, setStaffList] = useState([]);
  const [itemsOptions, setItemsOptions] = useState([]);
  const url = API_BASE_URL
  const token = decryptToken("accessToken") || ""
  const total = subtotal + parseFloat(shipping || 0);
  const discount_amount = (items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0) * subtotal / 100;
  const pending = subtotal - discount_amount - advance_payment;
  const tax = (pending * (items.reduce((acc, row) => acc + (parseFloat(row.tax) || 0), 0) / items.length || 0)) / 100;
  const grand_total = subtotal - discount_amount + tax + shipping;

  const [totals, setTotals] = useState({
    subtotal: 0,
    discount_amount: 0,
    advance_payment: 0,
    pending: 0,
    tax: 0,
    shipping: 0,
    grand_total: 0
  });


  const updateDueDate = (startDate, terms) => {
    if (!startDate || !terms) {
      setData(prev => ({ ...prev, due_date: "" }));
      return;
    }

    const date = new Date(startDate);
    let daysToAdd = 0;

    switch (terms) {
      case '15-net': daysToAdd = 15; break;
      case '30-net': daysToAdd = 30; break;
      case '45-net': daysToAdd = 45; break;
      case '60-net': daysToAdd = 60; break;
      case 'end-month':
        date.setMonth(date.getMonth() + 1);
        date.setDate(0);
        setData(prev => ({ ...prev, due_date: date.toISOString().split('T')[0] }));
        return;
      case 'next-month':
        date.setMonth(date.getMonth() + 2);
        date.setDate(0);
        setData(prev => ({ ...prev, due_date: date.toISOString().split('T')[0] }));
        return;
      default: daysToAdd = 0;

    }

    date.setDate(date.getDate() + daysToAdd);
    setData(prev => ({ ...prev, due_date: date.toISOString().split('T')[0] }));
  };

  const [customers, setCustomers] = useState([]);

  /** Stable key for API + invoice row (cust_ID preferred, else DB id). */
  const getCustomerRowKey = (c) => {
    if (!c) return "";
    const cid = c.cust_ID != null ? String(c.cust_ID).trim() : "";
    if (cid) return cid;
    return c.id != null ? String(c.id) : "";
  };

  const customerDisplayLabel = (c) =>
    c.displayName || c.companyName || c.customerName || getCustomerRowKey(c);

  const fetchCustomers = async () => {
    try {
      const response = await fetch(`${url}/api/customer/all/${isLoggedIn.main_id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const data = await response.json();
      // const parsedCustomers = data.customers.map((customer) => ({
      //   ...customer,
      //   billingAddress: customer.billingAddress ? JSON.parse(customer.billingAddress) : {},
      //   shippingAddress: customer.shippingAddress ? JSON.parse(customer.shippingAddress) : {},
      //   contact: customer.contact ? JSON.parse(customer.contact) : [],
      // }));
      console.log(data)
      setCustomers(data.reverse());
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };


  // Close the modal
  const handleModalClose = () => {
    setModalOpen(false);
  };

  // Handle input change in the modal form
  const handleSalesPersonInputChange = (event) => {
    const { name, value } = event.target;
    setNewSalesPerson({ ...newSalesPerson, [name]: value });
  };

  // Submit the new sales person to the list
  const handleAddSalesPersonSubmit = () => {
    if (newSalesPerson.name && newSalesPerson.email) {
      setSalesPersons([...salesPersons, newSalesPerson]);
      setModalOpen(false); // Close the modal after adding
      setNewSalesPerson({ name: '', email: '' }); // Reset the form
    } else {
      alert('Please fill in both fields!');
    }
  }

  // const fetchStaffNameId = async () => {
  //   try {
  //     const response = await fetch(`${url}/staffregister/allget/${isLoggedIn.main_id}`);
  //     const res = await response.json();

  //     // Assuming response is like: [{ id: 1, employee_name: "Ashish" }, ...]
  //     setStaffList(res);
  //   } catch (error) {
  //     console.error('Error fetching staff:', error);
  //   }
  // };

  console.log(items)
  const handleSubmit = async (e, dpStatus = "Published") => {
    e.preventDefault();

    if (isSubmitting) return; // prevent double click

    setIsSubmitting(true);
    setSubmitType(dpStatus);

    const isEditing = !!editInvoice;
    const endpoint = isEditing
      ? `${url}/newinvoice/update/${editInvoice.order_number}/${isLoggedIn.main_id}`
      : `${url}/newinvoice`;


    const method = isEditing ? "PUT" : "POST";

    const payload = {
      ...data,
      invoice_number: `${invoicePrefix}${invoiceNumberNumeric}`,
      created_by: "admin",
      dpstatus: dpStatus,
      customer_note: customerNote,
      items: items.map(row => ({
        id: row.id,
        item: row.item, // full object
        hsn: row.hsn,
        quantity: row.quantity,
        rate: row.rate,
        discount: row.discount,
        tax: row.tax,
        amount: (
          (row.quantity || 0) *
          (row.rate || 0) *
          (1 - (row.discount || 0) / 100) *
          (1 + (row.tax || 0) / 100)
        ).toFixed(2),
      })),
      subtotal: totals.subtotal,
      discount_amount: totals.discount_amount,
      advance_payment: totals.advance_payment,
      pending: totals.pending,
      tax: totals.tax,
      shipping: totals.shipping,
      grand_total: totals.grand_total,
      user_id: isLoggedIn.main_id,
      user_name: isLoggedIn.full_name
    };

    try {
      const res = await fetch(endpoint, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload)
      });

      const result = await res.json();

      if (!res.ok) {
        if (result.message?.includes("Invoice number already exists")) {
          toast.error("Invoice number already exists. Please use a unique one.");
          setInvoiceNumberError("Invoice number already exists. Please use a unique one.");
        } else {
          toast.error("Something went wrong. Please try again.");
        }
        return;
      }

      // Success Alert
      if (dpStatus === "Draft") {
        toast.success("Invoice Draft Saved Successfully!");
        navigate("/invoice");
      } else {
        toast.success(isEditing ? "Invoice updated successfully!" : "Invoice submitted successfully!");
        navigate("/invoice");
      }

      console.log("Submitted invoice:", result);

      // Reset Form
      setData(prev => ({
        ...prev,
        customer_name: "",
        invoice_date: new Date().toISOString().split("T")[0],
        terms: "",
        due_date: "",
        sales_person_name: "",
        sales_person_id: "",
        customer_id: ""
      }));

      setCustomerNote("");
      setShipping(0);
      setItems([{ id: 1, item: null, quantity: "", rate: "", discount: "", tax: "", hsn: "" }]);
      setAdvancePayment(0);
      setInvoiceNumberError("");


      // Refetch latest invoice/order number only if not editing
      if (!isEditing) {
        const [invoiceRes, orderRes] = await Promise.all([
          fetch(`${url}/newinvoice/next-number/${isLoggedIn.main_id}`),
          fetch(`${url}/newinvoice/next-order-number/${isLoggedIn.main_id}`)
        ]);

        const invoiceData = await invoiceRes.json();
        const orderData = await orderRes.json();

        console.log(invoiceData)
        setInvoiceNumberNumeric(invoiceData.invoice_no.replace("INVE", ""));
        setData(prev => ({
          ...prev,
          invoice_no: invoiceData.invoice_no,
          order_no: orderData.order_no
        }));
      } else {
        // toast.success("Invoice updated successfully!", {
        //   position: "top-center",
        //   autoClose: 2000,
        // });
        // After update, redirect to invoice list
        navigate("/invoice");
        // toast.success("Invoice updated successfully!",
        //   {
        //     position: "top-center",
        //     autoClose: 2000,

        //   });

      }

    } catch (error) {
      // toast.error("Error submitting invoice. Please try again.", {
      //   position: "top-center",
      //   autoClose: 2000,
      // });
      console.error("Submit error:", error);
      // alert("Failed to submit invoice.");
    } finally {
      setIsSubmitting(false);
      setSubmitType("");
    }
  };


  const handleChange = (e, actionMeta) => {
    if (actionMeta) {
      const { name } = actionMeta;
      const value = e?.value || "";

      setData((prev) => ({
        ...prev,
        [name]: value,
      }));

      if (name === "customer_name" && value === "new-customer") {
        navigate("/add-customer");
      }

      if (name === "terms") {
        if (value === "custom") {
          // Let the user set the date manually — don't update
          return;
        }

        if (data.invoice_date) {
          updateDueDate(data.invoice_date, value);
        }
      }

      if (name === "sales_person_name" && value === "add-new-salesperson") {
        setModalOpen(true);
      }

    } else {
      const { name, value } = e.target;
      setData((prev) => ({
        ...prev,
        [name]: value,
      }));

      if (name === "invoice_date" && data.terms) {
        updateDueDate(value, data.terms);
      }
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      if (editInvoice) {
        const {
          invoice_number,
          order_number,
          invoice_date,
          terms,
          due_date,
          sales_person_name,
          customer_name,
          items,
          customer_note,
          shipping,
          advance_payment,
          customer_id,
          sales_person_id
        } = editInvoice;

        setData({
          customer_name,
          invoice_number,
          order_number,
          invoice_date,
          terms,
          due_date,
          sales_person_name,
          customer_id,
          sales_person_id
        });
        setCustomerNote(customer_note || "");
        fetchDataProfile(customer_note || "");

        setInvoiceNumberNumeric(invoice_number.replace("INVE", ""));

        // ✅ Robust parsing logic
        let parsedItems = [];

        try {
          if (typeof items === "string") {

            let firstParse = JSON.parse(items);

            if (typeof firstParse === "string") {
              firstParse = JSON.parse(firstParse);
            }

            if (Array.isArray(firstParse)) {
              parsedItems = firstParse;
            } else {
              throw new Error("Parsed 'items' is not an array");
            }

          } else if (Array.isArray(items)) {
            parsedItems = items;
          } else {
            throw new Error("Invalid format: 'items' must be an array or JSON string");
          }
        } catch (err) {
          console.error("Invalid items format:", err);
          parsedItems = [];
        }

        if (Array.isArray(parsedItems)) {
          const hydratedItems = parsedItems.map(row => {
            if (row.item && typeof row.item === "object" && !row.item.id) {
              const matched = itemsOptions.find(opt =>
                opt.value.title === row.item.title
              );
              return {
                ...row,
                item: matched?.value || row.item
              };
            }
            return row;
          });

          setItems(hydratedItems);
          // setItems(hydratedItems);
        } else {
          console.error("Parsed items is not an array:", parsedItems);
          setItems([]);
        }






        setShipping(shipping || 0);
        setAdvancePayment(advance_payment || 0);


      } else {
        // Normal fresh create mode
        const [invoiceRes, orderRes] = await Promise.all([
          fetch(`${url}/newinvoice/next-number/${isLoggedIn.main_id}`),
          fetch(`${url}/newinvoice/next-order-number/${isLoggedIn.main_id}`)
        ]);
        const invoiceData = await invoiceRes.json();
        const orderData = await orderRes.json();
        const today = new Date().toLocaleDateString('en-CA');

        setInvoiceNumberNumeric(invoiceData.invoice_number.replace("INVE", ""));
        setData((prev) => ({
          ...prev,
          invoice_number: invoiceData.invoice_number,
          order_number: orderData.order_number,
          invoice_date: today
        }));
      }
    };

    fetchInitialData();
  }, []);
  const selectedStaff = staffList.find(s => s.emplyee_ID === data.sales_person_id);

  const fetchDataProfile = async (existingNote) => {
    const strippedNote = existingNote?.replace(/<\/?[^>]+(>|$)/g, "").trim();
    if (strippedNote) {
      console.log("✅ Skipping overwrite from profileData");
      return;
    }

    try {
      const profileRes = await fetch(`${url}/register/single/${isLoggedIn.main_id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const res = await profileRes.json();
      const profileData = res.users;
      setCustomerNote(profileData.custom_note || "");
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!editInvoice && customerNote === "") {
      fetchDataProfile();
    }
  }, [editInvoice, customerNote]);
  console.log(editInvoice)

  useEffect(() => {
    fetchCustomers();
    // fetchStaffNameId();
  }, []);

  console.log(data)

  return (
    <>
      <form className='oms-modal-form'>
        <div className="oms-form-flex">
          <div className="oms-form-group">
            <label htmlFor="name" className="oms-form-label">Customer Name</label>
            <Select
              name="customer_name"
              value={(() => {
                if (!data.customer_id && !data.customer_name) return null;
                const byKey = customers.find(
                  (c) => getCustomerRowKey(c) === String(data.customer_id || "").trim()
                );
                if (byKey) {
                  return {
                    value: getCustomerRowKey(byKey),
                    label: customerDisplayLabel(byKey),
                  };
                }
                return {
                  value: data.customer_id || data.customer_name,
                  label: data.customer_name || data.customer_id || "",
                };
              })()}
              onChange={(e) => {
                if (!e) {
                  setData((prev) => ({
                    ...prev,
                    customer_name: "",
                    customer_id: "",
                  }));
                  return;
                }
                if (e.value === "new-customer") {
                  navigate("/add-customer");
                  return;
                }
                const selectedCustomer = customers.find(
                  (c) => getCustomerRowKey(c) === String(e.value)
                );
                setData((prev) => ({
                  ...prev,
                  customer_name: selectedCustomer
                    ? customerDisplayLabel(selectedCustomer)
                    : e.label || String(e.value),
                  customer_id: selectedCustomer
                    ? getCustomerRowKey(selectedCustomer)
                    : String(e.value),
                }));
              }}
              options={[
                ...customers
                  .filter((c) => getCustomerRowKey(c))
                  .map((c) => ({
                    value: getCustomerRowKey(c),
                    label: customerDisplayLabel(c),
                  })),
                { value: "new-customer", label: "Add New Customer" },
              ]}
              placeholder="Select Customer Name"
            />



          </div>
          {/* {console.log(data.customer_id)} */}
          <div className="oms-form-group">
            <label htmlFor="customer_id" className="oms-form-label">Customer ID</label>
            <input
              type="text"
              name="customer_id"
              value={data.customer_id}
              readOnly
            />

          </div>



          <div className="oms-form-group">
            <label htmlFor="invoice_number" className="oms-form-label">Invoice Number</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ padding: '0.5rem', backgroundColor: 'white', border: '1px solid #ccc', borderRight: 'none', fontSize: '17px' }}>
                {invoicePrefix}
              </span>
              <input
                type="text"
                name="invoice_number"
                value={invoiceNumberNumeric}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  setInvoiceNumberNumeric(value);
                }}
                placeholder="00001"
                style={{ flex: 1, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                disabled={editInvoice}
              />
            </div>
            {invoiceNumberError && (
              <div style={{ color: "red", fontSize: "13px", marginTop: "4px" }}>
                {invoiceNumberError}
              </div>
            )}
          </div>


          <div className="oms-form-group">
            <label htmlFor="order-number" className="oms-form-label">Order number</label>
            <input type="number" name="order_number" value={data.order_number} onChange={handleChange} readOnly />
          </div>

          <div className="oms-form-group">
            <label htmlFor="invoice-date" className="oms-form-label">Invoice Date</label>
            <input
              type="date"
              name="invoice_date"
              value={data.invoice_date}
              onChange={handleChange}
              required
            />
          </div>

          <div className="oms-form-group">
            <label htmlFor="terms" className="oms-form-label">Terms</label>
            <Select
              name="terms"
              options={[
                { value: '', label: 'Select an option' },
                { value: '15-net', label: '15 Net' },
                { value: '30-net', label: '30 Net' },
                { value: '45-net', label: '45 Net' },
                { value: '60-net', label: '60 Net' },
                { value: 'end-month', label: 'Due end of the month' },
                { value: 'next-month', label: 'Due end of next month' },
                { value: 'custom', label: 'Custom' }
              ]}
              value={data.terms ? { value: data.terms, label: data.terms } : null}
              onChange={handleChange}
              placeholder="Select Terms"
            />
          </div>

          <div className="oms-form-group">
            <label htmlFor="due-date" className="oms-form-label">Due Date</label>
            <input
              type="date"
              name="due_date"
              value={data.due_date}
              onChange={handleChange}
              disabled={data.terms !== "custom"} // disabled unless custom is selected
            />

          </div>

          {/* <div className="oms-form-group">
              <label htmlFor="sale" className="oms-form-label">Sales Person</label>
              <Select
                name="sales_person_name"
                value={
                  selectedStaff
                    ? {
                      value: selectedStaff.emplyee_ID,
                      label: `${selectedStaff.firstName} ${selectedStaff.lastName} - ${selectedStaff.emplyee_ID}`
                    }
                    : null
                }
                onChange={(selectedOption) => {
                  if (selectedOption.value === "add-new-salesperson") {
                    setModalOpen(true);
                    return;
                  }

                  const selectedStaff = staffList.find(s => s.emplyee_ID === selectedOption.value);
                  if (selectedStaff) {
                    setData(prev => ({
                      ...prev,
                      sales_person_name: `${selectedStaff.firstName} ${selectedStaff.lastName}`.trim(),
                      sales_person_id: selectedStaff.emplyee_ID
                    }));
                  }
                }}
                options={[
                  ...staffList.map(staff => ({
                    value: staff.emplyee_ID,
                    label: `${staff.firstName} ${staff.lastName} - ${staff.emplyee_ID}`
                  })),
                  { value: "", label: "Select Sales Person" }
                ]}
                placeholder="Select Sales Person"
              />

            </div>
            <div className="oms-form-group">
              <label htmlFor="sales_person_id" className="oms-form-label">Sales Person ID</label>
              <input type="text" name="sales_person_id" value={data.sales_person_id} onChange={handleChange} />
            </div> */}



          {/* Sales Person Dropdown */}

        </div>

        {/* Modal for adding a new Sales Person */}
        {modalOpen && (
          <div className="sale-person-modal open">
            <div className="sale-person-modal-content">
              <span className="close-btn" onClick={handleModalClose}>
                <i className="fa-solid fa-xmark"></i>
              </span>
              <h3>Add Sales Person</h3>
              <label htmlFor="salesPersonName">Name</label>
              <input
                type="text"
                name="name"
                value={newSalesPerson.name}
                onChange={handleSalesPersonInputChange}
                placeholder="Sales Person Name"
              />
              <label htmlFor="salesPersonEmail">Email</label>
              <input
                type="email"
                name="email"
                value={newSalesPerson.email}
                onChange={handleSalesPersonInputChange}
                placeholder="Sales Person Email"
              />
              <button type="button" onClick={handleAddSalesPersonSubmit}>Add Sales Person</button>
            </div>
          </div>
        )}
        {/* item table */}
        <ItemTable items={items} setItems={setItems} setSubtotal={setSubtotal} itemsOptions={itemsOptions} setItemsOptions={setItemsOptions} />

        <TotalSection
          items={items}
          setShipping={setShipping}
          shipping={shipping}
          customerNote={customerNote}
          setCustomerNote={setCustomerNote}
          setTotals={setTotals}
          advance_payment={advance_payment}
          editInvoice={editInvoice}

          setAdvancePayment={setAdvancePayment}
        />

        {/* Buttons */}

        {/* <div className="oms-form-actions">
          <button type="button" onClick={() => navigate("/invoice")}>Cancel</button>
          <button type="button" onClick={(e) => handleSubmit(e, "Draft")}>Draft</button>
          <button type="submit" onClick={(e) => handleSubmit(e, "Published")}>Submit</button>
        </div> */}
        <div className="oms-form-actions">
          <button
            type="button"
            onClick={() => navigate("/invoice")}
            disabled={isSubmitting}
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={(e) => handleSubmit(e, "Draft")}
            disabled={isSubmitting}
          >
            {isSubmitting && submitType === "Draft" ? "Saving..." : "Draft"}
          </button>

          <button
            type="submit"
            onClick={(e) => handleSubmit(e, "Published")}
            disabled={isSubmitting}
          >
            {isSubmitting && submitType === "Published"
              ? "Submitting..."
              : "Submit"}
          </button>
        </div>


      </form>
    </>
  );
};

export default NewInvoice;
